import { makeAutoObservable, runInAction } from 'mobx'
// evertel
import { injectable, inject, decorate } from '@evertel/di'
import { Api } from '@evertel/api'
import { uniqBy } from 'lodash'
import { APIDataInvite } from '@evertel/types'

export type InviteStatus = 'valid'|'consumed'|'deleted'|'expired'

class RoomInvitesController {
    roomId = 0
    invites: APIDataInvite[] = []
    invitesLatestFetch: APIDataInvite[] = []
    invitesCount = 0
    inviteStatus = null
    inviteIsPersistent = false
    isLoading = false

    constructor(
        private api: Api
    ) {
        makeAutoObservable(this)
    }

    init = async (roomId: number) => {
        if (!roomId) console.error('Missing roomId! in RoomInvitesController.init')

        this.roomId = roomId

        this.resetSearch()

    }

    setInviteStatus = (status: InviteStatus | null | 'all') => {
        this.resetSearchMeta()
        if (!status || status === 'all') {
            this.inviteStatus = undefined
        } else {
            this.inviteStatus = status
        }
    }

    resetSearchMeta(): void {
        // this.page = 1
        this.invites = []
        this.invitesCount = 0
    }

    resetSearch(): void {
        this.inviteStatus = undefined
        this.resetSearchMeta()
    }

    search = async () => {
        if (!this.roomId) return

        runInAction(() => {
            this.isLoading = true
            this.invitesLatestFetch = []
        })

        const newInvites = await this.api.Routes.Room.getInvites(this.roomId, this.filter)

        runInAction(() => {
            this.invitesLatestFetch = newInvites
            this.invites = uniqBy([...this.invites, ...newInvites], 'id')
            this.invitesCount = this.invites.length // temporary solution until there is a count endpoint

            this.isLoading = false
        })
    }

    delete = async (inviteId: number) => {
        const msg = await this.api.Routes.Room.delInvitesById(this.roomId, inviteId)

        runInAction(() => {
            this.invites = this.invites.filter(i => i.id !== inviteId)
        })
    }

    get filter() {
        return {
            where: {
                status: this.inviteStatus ?? undefined,
                isPersistent: this.inviteIsPersistent
            },
            order: 'createdTime DESC'
        }
    }
}

decorate(injectable(), RoomInvitesController)
decorate(inject(Api), RoomInvitesController, 0)

export { RoomInvitesController }
